import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

import logo from "../assets/logo-symbol.png";

const Footer = () => {
  return (
    <footer className="footer-wrap">

      <div className="container footer-grid">

        {/* BRAND */}

        <div className="footer-brand">

          <img src={logo} alt="Prime Equilibrium" />

          <h2>

            <span className="footer-prime">PRIME</span>

            <span className="footer-equilibrium">
              EQUILIBRIUM
            </span>

          </h2>

          <p className="footer-tagline">

            Empowering lives.
            <br />

            Creating balance.

          </p>

        </div>

        {/* CONTACT */}

        <div>

          <h3>Contact</h3>

          <ul>

            <li>

              <FaPhoneAlt />

              0421 390 040

            </li>

            <li>

              <FaEnvelope />

              info@primeequilibrium.com

            </li>

            <li>

              <FaMapMarkerAlt />

              Australia

            </li>

          </ul>

        </div>

        {/* LINKS */}

        <div>

          <h3>Quick Links</h3>

          <ul>

            <li><Link to="/">Home</Link></li>

            <li><Link to="/about-us">About</Link></li>

            <li><Link to="/services">Services</Link></li>

            <li><Link to="/referrals">Refer a Participant</Link></li>

            {/* <li><Link to="/faqs">FAQs</Link></li> */}

          </ul>

        </div>

        {/* SOCIAL */}

        <div>

          <h3>Follow Us</h3>

          <div className="footer-social">

            <a
              href="https://facebook.com/primeequilibrium"
              target="_blank"
              rel="noreferrer"
            >

              <FaFacebookF />

            </a>

            <a
              href="#"
              target="_blank"
              rel="noreferrer"
            >

              <FaLinkedinIn />

            </a>

          </div>

          <p className="footer-small">

            Supporting community through compassionate occupational therapy.

          </p>

        </div>

      </div>

      <div className="footer-bottom">

        <div className="container footer-bottom-wrap">

          <p>

            © {new Date().getFullYear()} Prime Equilibrium Occupational Therapy

          </p>

          <div>

            <Link to="/privacy-policy">

              Privacy Policy

            </Link>

            <Link to="/terms">

              Terms of Use

            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;
